export default "__VITE_PUBLIC_ASSET__b0b02a4e__"